<dashboard-dialog-frame [icon]='icon()' [header]='header()' [actions]='actions' [dialogRef]='dialogRef'>
	<div class="event-dialog">
		<div class='timezone-message'>
			<small>All times are local to {{timezone}}.</small>
		</div>
		<kendo-tabstrip class="h-100 p-2">
			<kendo-tabstrip-tab title="Event" [selected]="true">
				<ng-template kendoTabContent>
					<event-details-part></event-details-part>
				</ng-template>
			</kendo-tabstrip-tab>

			<kendo-tabstrip-tab title="Edit">
				<ng-template kendoTabContent>
				<event-dialog-editor-part (closeDialog)="close()"></event-dialog-editor-part>
				</ng-template>
			</kendo-tabstrip-tab>
		</kendo-tabstrip>
	</div>
</dashboard-dialog-frame>